module.exports = __webpack_public_path__ + "static/media/lock.4a0972aa.svg";